import {Component, Fragment, h} from "preact";
import './dropdownSelector.scss';
import {useEffect, useState} from "preact/hooks";

export default function DropdownSelector({ values, onChange, fullWidth, iconDropdownVisible, iconDropdownHidden, selected }){
    const [value, setValue] = useState(values ? values[0] : { id: 0, name: ''});
    const [selectorView, setSelectorView] = useState(false);
    const iconSelected = selectorView ? iconDropdownVisible : iconDropdownHidden;

    useEffect(() => {
        function docClick() {
            selectorView && setSelectorView(false)
        }
        document.addEventListener("click", docClick);
        return () => {
            document.removeEventListener("click", docClick);
        };
    }, [selectorView]);

    useEffect(() => {
        if (selected && selected.id !== value?.id) setValue(selected);
    }, [selected]);

    const handleSelectorView = () => {
        setSelectorView(!selectorView)
    }

    const handleSelect = (index) => {
        setValue(values[index])
        onChange(values[index])
    }

    return (
        <div className={`dropdownSelector-container ${fullWidth === 'fullWidth' ? 'fullWidth' : ''}`} onClick={handleSelectorView}>
            <div className={`dropdownSelector-header ${fullWidth === 'fullWidth' ? 'fullWidth' : ''}`}>
                <span className='dropdownSelector-header__title'>{value?.name || value?.title}</span>
                <span className='dropdownSelector-header__icon'>{iconSelected}</span>
            </div>
            { selectorView && <div className={`dropdownSelector-dropdown  ${fullWidth === 'fullWidth' ? 'fullWidth' : ''}`}>
                {values.map((valueItem, index) => <div key={valueItem.id} className='dropdownSelector-dropdown__item ' onClick={() => handleSelect(index)}>{valueItem?.name || valueItem?.title}</div>)}
            </div>}
        </div>
    )
}
